export default __webpack_public_path__ + "static/media/4478.413e14ea.png";